// extracted by mini-css-extract-plugin
export default {"imgCard":"upload-img_imgCard__IVrDF"};